import React from "react";

const ResumenTurnos = ({ turnos }) => {
  const hoy = new Date().toISOString().split("T")[0];
  const seña = 5000; // ajustar si querés

  // Turnos por día
  const mapaDias = {};
  turnos.forEach((t) => {
    if (!mapaDias[t.fecha]) mapaDias[t.fecha] = 0;
    mapaDias[t.fecha]++;
  });

  const ranking = Object.entries(mapaDias)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5); // top 5 días

  const totalTurnos = turnos.length;
  const totalSeñas = totalTurnos * seña;

  const turnosDelDia = turnos.filter((t) => t.fecha === hoy).length;
  const señadoHoy = turnosDelDia * seña;

  return (
    <div className="resumen-container">
      <h2>Resumen General</h2>

      <div className="resumen-grid">
        <div className="resumen-card">
          <h4>Turnos totales</h4>
          <p>{totalTurnos}</p>
        </div>

        <div className="resumen-card">
          <h4>Señas totales</h4>
          <p>${totalSeñas}</p>
        </div>

        <div className="resumen-card">
          <h4>Turnos de hoy</h4>
          <p>{turnosDelDia}</p>
        </div>

        <div className="resumen-card">
          <h4>Señado hoy</h4>
          <p>${señadoHoy}</p>
        </div>
      </div>

      <h3>Top 5 días con más turnos</h3>
      <ul className="ranking-list">
        {ranking.map(([dia, cantidad]) => (
          <li key={dia}>
            <b>{dia}</b>: {cantidad} turnos
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ResumenTurnos;
